import {IconProps} from "../icons";
import {themeColors} from "../../../styles/theme";


export const ThemeSwitchIcon = ({width = 24, height = 24, color = themeColors.navyBlue}: IconProps) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.5 1C3.71 2.15 2.5 4.18 2.5 6.5C2.5 8.82 3.71 10.85 5.53 12C2.46 12 0 9.54 0 6.5C0 5.04131 0.579463 3.64236 1.61091 2.61091C2.64236 1.57946 4.04131 1 5.5 1ZM17.07 2.5L18.5 3.93L2.93 19.5L1.5 18.07L17.07 2.5ZM10.89 4.93L9.41 4L7.97 5L8.39 3.3L7 2.24L8.75 2.12L9.33 0.470001L10 2.1L11.73 2.13L10.38 3.26L10.89 4.93ZM7.59 8.54L6.43 7.81L5.31 8.59L5.65 7.27L4.56 6.44L5.92 6.35L6.37 5.06L6.88 6.33L8.24 6.36L7.19 7.23L7.59 8.54ZM17 12.5C17 13.9587 16.4205 15.3576 15.3891 16.3891C14.3576 17.4205 12.9587 18 11.5 18C10.28 18 9.15 17.6 8.24 16.93L15.93 9.24C16.6 10.15 17 11.28 17 12.5ZM12.6 19.08L15.37 17.93L15.13 21.28L12.6 19.08ZM16.93 16.38L18.08 13.61L20.28 16.15L16.93 16.38ZM18.08 11.42L16.94 8.64L20.28 8.88L18.08 11.42ZM7.63 17.93L10.4 19.08L7.87 21.27L7.63 17.93Z"
        fill={color}/>
    </svg>
  )
}